var _Path, _Path2, _Path3, _Path4, _Path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgDietNutrition = function SvgDietNutrition(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "M44.775 4.825a10.476 10.476 0 0 0-9.225 10.4V34.1h9.225zM36.851 6.05a12.98 12.98 0 0 1 9.174-3.8c.69 0 1.25.56 1.25 1.25v31.85c0 .69-.56 1.25-1.25 1.25H34.3c-.69 0-1.25-.56-1.25-1.25V15.225c0-3.441 1.367-6.741 3.8-9.175",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "M37.95 35.175c0-.69.56-1.25 1.25-1.25h6.825c.69 0 1.25.56 1.25 1.25v14.7A4.575 4.575 0 0 1 42.7 54.45h-.175a4.575 4.575 0 0 1-4.575-4.575zm2.5 1.25v13.45a2.075 2.075 0 0 0 2.075 2.075h.175a2.075 2.075 0 0 0 2.075-2.075v-13.45z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M13.279 27.2a1.25 1.25 0 0 1 1.246-1.15h4.725c.651 0 1.194.5 1.246 1.15l1.75 21.875q.003.048.004.098a5.275 5.275 0 0 1-5.477 5.276 5.275 5.275 0 0 1-5.248-5.275q0-.05.004-.1zm2.4 1.35-1.654 20.67a2.775 2.775 0 0 0 2.829 2.73 2.775 2.775 0 0 0 2.895-2.73l-1.653-20.67z",
    clipRule: "evenodd"
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M13.279 27.2a1.25 1.25 0 0 1 1.246-1.15h4.725c.651 0 1.194.5 1.246 1.15l1.75 21.875q.003.048.004.098a5.275 5.275 0 0 1-5.477 5.276 5.275 5.275 0 0 1-5.248-5.275q0-.05.004-.1zm2.4 1.35-1.654 20.67a2.775 2.775 0 0 0 2.829 2.73 2.775 2.775 0 0 0 2.895-2.73l-1.653-20.67z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M7.803 18.608a1.25 1.25 0 0 1 .947-.434h15.925a1.25 1.25 0 0 1 1.236 1.434 9.3 9.3 0 0 1-18.397 0 1.25 1.25 0 0 1 .29-1m2.56 2.066a6.799 6.799 0 0 0 12.7 0z",
    clipRule: "evenodd"
  }), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M7.803 18.608a1.25 1.25 0 0 1 .947-.434h15.925a1.25 1.25 0 0 1 1.236 1.434 9.3 9.3 0 0 1-18.397 0 1.25 1.25 0 0 1 .29-1m2.56 2.066a6.799 6.799 0 0 0 12.7 0z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M8.75 3.65c.69 0 1.25.56 1.25 1.25v14.524a1.25 1.25 0 1 1-2.5 0V4.9c0-.69.56-1.25 1.25-1.25",
    clipRule: "evenodd"
  }), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M8.75 3.65c.69 0 1.25.56 1.25 1.25v14.524a1.25 1.25 0 1 1-2.5 0V4.9c0-.69.56-1.25 1.25-1.25",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M16.625 3.65c.69 0 1.25.56 1.25 1.25v14.175a1.25 1.25 0 1 1-2.5 0V4.9c0-.69.56-1.25 1.25-1.25",
    clipRule: "evenodd"
  }), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M16.625 3.65c.69 0 1.25.56 1.25 1.25v14.175a1.25 1.25 0 1 1-2.5 0V4.9c0-.69.56-1.25 1.25-1.25",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M24.675 3.65c.69 0 1.25.56 1.25 1.25v14.525a1.25 1.25 0 0 1-2.5 0V4.9c0-.69.56-1.25 1.25-1.25",
    clipRule: "evenodd"
  }), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M24.675 3.65c.69 0 1.25.56 1.25 1.25v14.525a1.25 1.25 0 0 1-2.5 0V4.9c0-.69.56-1.25 1.25-1.25",
    clipRule: "evenodd"
  })));
};
export default SvgDietNutrition;